import h from './h.module.scss';
import m from './m.module.scss';
import Sidebar, { openNav } from '../sidebar';
import { GiHamburgerMenu } from 'react-icons/gi';
import { useApiProviderCtx } from '../../context/api';

export default function MyHeader() {
  //userbaselink
  const { userbaselink } = useApiProviderCtx();
  return (
    <>
      <Sidebar />
      <div className={h.fn}>
        <div className={h.whole1}>
          <div className={h.whole}>
            <div className={h.see2}>
              <div className={h.see2c1}>
                <a href="/en">
                  <b>knowledge for development</b>
                </a>
                <a href="/en/about">About</a>
                <a href="/en/pricing">Pricing</a>
              </div>
              <div>
                <a href={`${userbaselink}/auth/login`}>login</a>
                <a href={`${userbaselink}/auth/signup`}>register</a>
              </div>
            </div>
          </div>
        </div>
        <div className={h.whole2}>
          <div className={h.whole}>
            <div className={h.see}>
              <form>
                <input type="search" name="search" placeholder="Search for articles..." />
              </form>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div className={m.mn}>
          <div className={m.ht}>knowledge For development</div>
          <div
            onClick={() => {
              openNav();
            }}
          >
            <GiHamburgerMenu />
          </div>
        </div>
        <div className={h.whole2}>
          <div className={h.whole}>
            <div className={h.see}>
              <form>
                <input type="search" name="search" placeholder="Search for articles..." />
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
